import React from 'react';

const Label = ({children, type}) => {

    let labelDisplay;

    switch(type){
        case 'new':
        default:
            labelDisplay = 'is-primary'
    }

    return (
        <span
            className={`tag ${labelDisplay}`}
        >
        {children}
    </span>
    )
}

export default Label;


// WEBPACK FOOTER //
// ./src/components/label/index.js